module.exports = __webpack_public_path__ + "img/empty.8605ee37.png";